import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";

import SocketContext from "@contexts/socket/socketContext";

// REACT_APP_SOCKET_SERVER_URL=http://localhost:3333
const { REACT_APP_SOCKET_SERVER_URL } = process.env;

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  useEffect(() => {
    const newSocket = io(REACT_APP_SOCKET_SERVER_URL);
    setSocket(newSocket);
    return () => {
      newSocket.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider value={socket}>
      {socket ? children : null}
    </SocketContext.Provider>
  );
};
